import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Navigation } from 'app/core/navigation/navigation.types';
import { environment } from '@env/environment';
import { FuseNavigationItem } from '@fuse/components/navigation';

@Injectable({
    providedIn: 'root',
})
export class NavigationService {
    private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);

    constructor(private _httpClient: HttpClient) { }

    get navigation$(): Observable<Navigation> {
        return this._navigation.asObservable();
    }

    get(): Observable<Navigation> {
        // In non-mock environments, load navigation from backend
        // Backend returns a single array of FuseNavigationItem (the "default" menu)
        // We map it into Navigation shape; for now, reuse the same items for all variants
        return this._httpClient
            .get<FuseNavigationItem[]>(`${environment.apiv2}/client-services/get-system-menu`)
            .pipe(
                map((items) => {
                    const navigation: Navigation = {
                        default: items,
                        compact: items,
                        horizontal: items,
                    };
                    return navigation;
                }),
                tap((navigation) => this._navigation.next(navigation)),
                catchError((err) => {
                    // Fallback to a minimal empty navigation on error
                    const empty: FuseNavigationItem[] = [];
                    const fallback: Navigation = {
                        compact: empty,
                        default: empty,
                        horizontal: empty,
                    };
                    this._navigation.next(fallback);
                    return of(fallback);
                })
            );
    }
}
